export const innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2901_39116)">
<path d="M4.74577 13.2215L7.79077 2.72148C7.91472 2.29407 8.30619 2 8.7512 2H12.4688H16.1254C16.855 2 17.339 2.75607 17.0335 3.41865L13.625 10.8125H17.7349C18.5783 10.8125 19.0429 11.7923 18.5091 12.4454L10.9186 21.7321C10.2784 22.5153 9.0132 21.9617 9.15406 20.96L10.0625 14.5H5.7062C5.04017 14.5 4.56027 13.8611 4.74577 13.2215Z" fill="currentcolor"/>
</g>
<defs>
<clipPath id="clip0_2901_39116">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;
